import { Typography } from "@packages/ds";
import styled from "styled-components";

export const AddonCtaWrapper = styled.div`
  border: double 1px transparent;
  border-radius: 16px;
  background-image: linear-gradient(
      var(--section-grey-light-background-color, var(--grey-light)),
      var(--section-grey-light-background-color, var(--grey-light))
    ),
    linear-gradient(to bottom, #ff4a11, #ed49f0, #ddf933);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  padding: 16px 24px;
  position: relative;
`;

export const AddonCtaTitle = styled(Typography.BodyText).attrs({
  weight: "bold"
})`
  margin-bottom: 8px;
`;

export const AddonCtaButtonWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 16px;
`;

export const TagWrapper = styled.div`
  margin-bottom: 16px;
`;
